import styled from 'styled-components';
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";

export const Circulo = styled.div`
  background-color: ${props => props.theme.colors.c02};
  width: 120%;
  height: 100%;
  border-Radius: 50%;
  transform: translate(35%, 0%);
  justifyContent: left;
  align-Items: center;
`;

export const CirculoText = styled.div`
  font-family: Arial;
  font-size: 200%;
  color: ${props => props.theme.colors.c05};
  padding: 40% 0 0 10%;
`;

export const Titulo = styled.div`
  font-size: 22px;
  color: ${props => props.theme.colors.c02};
  padding: 5% 0 0 5%;
`;

export const Linha = styled.div`
  width: 100%;
  margin: 12px 0 12px 0;
  border-bottom: 2px solid ${props => props.theme.colors.c02};
`;

export const ImgInput = styled.img`
  margin: 0 0 0 40px;
  width: 25px;
`;

export const InputLogin = styled.input`
  width: 85%;
  height: 25px;
  background-color: transparent;
  color: ${props => props.theme.colors.c05};
  border-radius: 10px;
  font-size: 16px;
  border-radius: 10px;
  outline: none;
  margin: 0 0 0 10px;
  border-color: "transparent";
  text-decoration: none;
`;

export const EyeOpen = styled(AiFillEye)`
  cursor: pointer;
  /* margin: 8px 0 -8px -40px; */
  color: ${props => props.theme.colors.c02};
`;

export const EyeClose = styled(AiFillEyeInvisible)`
  cursor: pointer;
  /* margin: 8px 0 -8px -40px; */
  color: ${props => props.theme.colors.c02};
`;

export const CardOption = styled.div`
  width: 100%;
  background: transparent;
  color: ${props => props.theme.colors.c02};
  margin: 0px;
  border: 0px;
  display: flex;
  flex-direction: row;
`;

export const CardImg = styled.div`
  width: 50px;
  height: 50px;
  margin: 0;
  border: 0px;
  padding: 10px;
  border-radius: 5px;
  margin: 0px 10px 0px 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

export const LoginBtn = styled.button`
  width: 30%;
  height: 40px;
  font-family: Segoe UI;
  font-size: 15px;
  background-color: ${props => props.theme.colors.c02};;
  color: ${props => props.theme.colors.c05};
  border-radius: 10px;
  cursor: pointer;
  border: 2px solid ${props => props.theme.colors.c02}; 
  margin-top: 20px;
  margin-left: 10px;
  transition: all 0.2s;
  &:hover{
      opacity: 0.7;
  }
`;

export const LinkBtn = styled.a `
  background-color: transparent;
  color: ${props => props.theme.colors.c02};
  outline: 0 ;
  font-size: 25px;
  box-shadow: none;
  text-decoration: none;
  display: flex;
  width: 100%;
  height: auto;
  margin: 0;
  font-size: 12px;
  cursor: pointer;
`;
